export default __webpack_public_path__ + "static/media/budget-tracker.811649c0.gif";